var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 0H25.5C27.8242 0 29.75 1.92578 29.75 4.25V25.5C29.75 27.8906 27.8242 29.75 25.5 29.75H4.25C1.85938 29.75 0 27.8906 0 25.5V4.25C0 1.92578 1.85938 0 4.25 0ZM6.375 4.25C5.17969 4.25 4.25 5.24609 4.25 6.375V19.125C4.25 20.3203 5.17969 21.25 6.375 21.25H23.375C24.5039 21.25 25.5 20.3203 25.5 19.125V6.375C25.5 5.24609 24.5039 4.25 23.375 4.25H6.375ZM16.4688 8.5C16.8008 8.5 17.1328 8.69922 17.332 8.96484L23.1758 17.4648C23.375 17.7969 23.4414 18.2617 23.2422 18.5938C23.043 18.9258 22.6445 19.125 22.3125 19.125H16.4688H13.8125H10.625H7.4375C7.03906 19.125 6.64062 18.9258 6.44141 18.5938C6.30859 18.1953 6.30859 17.7969 6.57422 17.4648L9.76172 13.2148C9.96094 12.9492 10.293 12.75 10.625 12.75C10.957 12.75 11.2227 12.9492 11.4219 13.2148L12.0859 14.0781L15.5391 8.96484C15.7383 8.69922 16.0703 8.5 16.4688 8.5ZM8.5 10.625C7.30469 10.625 6.375 9.69531 6.375 8.5C6.375 7.37109 7.30469 6.375 8.5 6.375C9.62891 6.375 10.625 7.37109 10.625 8.5C10.625 9.69531 9.62891 10.625 8.5 10.625Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image_icon.eb3e40f6adf0b4e8bcb15fd2c096e0a9.svg";
export { ForwardRef as ReactComponent };